/** Public widget channel kinds returned by GET /public/webchat/:publicKey. */
export type WidgetChannelType =
  | 'telegram'
  | 'whatsapp'
  | 'messenger'
  | 'instagram'
  | 'webchat';

export type WidgetChannel = {
  id?: string;
  type: WidgetChannelType;
  enabled: boolean;
  available?: boolean;
  destination: string | null;
  displayName: string;
  icon: string;
  webchatPublicKey?: string | null;
};

export const WIDGET_CHANNEL_TYPES: readonly WidgetChannelType[] = [
  'telegram',
  'whatsapp',
  'messenger',
  'instagram',
  'webchat',
] as const;

export function isWidgetChannelType(value: string): value is WidgetChannelType {
  return (WIDGET_CHANNEL_TYPES as readonly string[]).includes(value);
}
